<div class="modal-header">
	<h4 class="modal-title pull-left">{{ title | translate }}</h4>
	<button
		type="button"
		class="btn-close close pull-right"
		aria-label="Close"
		(click)="bsModalRef.hide()"
	>
		<span aria-hidden="true" class="visually-hidden">&times;</span>
	</button>
</div>
<div class="modal-body">
	<app-datatable
		[value]="list"
		[totalElements]="totalElements"
		[columns]="columns"
		[hasFilters]="true"
		[hasSubFiltersButton]="false"
		[filters]="filters"
		(changeEvent)="refreshTable($event)"
		class="search-datatable"
	>
		<ng-template appAutomataTemplate="body" let-item>
			<tr (click)="selectRow(item)">
				<td *ngFor="let colum of columns">{{ item[colum.prop] }}</td>
			</tr>
		</ng-template>
	</app-datatable>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-default" (click)="bsModalRef.hide()">
		{{ closeBtnName | translate }}
	</button>
</div>
